(ns nosco.placeholders
  (:require
   [hx.react :as hx :refer [defnc]]
   [nosco.react :as nosco-react]))


(defnc Circle [{:keys [r x y] :as props}]
  [:div (nosco.react/merge-props
         {:class "placeholder-image-shape"
          :style {:border-radius "9999px"
                  :transform (str "translate(" x "cqw, " y "cqw)")
                  :width (str r "cqw")
                  :height (str r "cqw")}}
         props)])

(defnc Diamond [{:keys [r x y] :as props}]
  [:div (nosco.react/merge-props
         {:class "placeholder-image-shape"
          :style {:transform (str "translate(" x "cqw, " y "cqw) rotate(45deg)")
                  :width (str r "cqw")
                  :height (str r "cqw")}}
         props)])

(def placeholder-variants
  [(hx/f [:<>
          [Circle {:r 59  :x 29 :y -19}]
          [Circle {:r 59  :x -29 :y 19}]])
   (hx/f [:<>
          [Diamond {:r 33  :x 0 :y 0}]
          [Diamond {:r 19  :x 0 :y 0}]])
   (hx/f [:<>
          [Diamond {:r 53  :x 0 :y -39}]
          [Diamond {:r 53  :x 0 :y 39}]])
   (hx/f [:<>
          [Diamond {:r 40  :x 0 :y 0}]
          [Diamond {:r 43
                    :style {:transform "translate(-50cqw, -50cqh) rotate(45deg)"}}]
          [Diamond {:r 43
                    :style {:transform "translate(50cqw, 50cqh) rotate(45deg)"}}]])
   (hx/f [:<>
          [Diamond {:r 53 :x 43 :y -20}]
          [Diamond {:r 48 :x -10 :y 30}]
          [Diamond {:r 43 :x -35 :y -30}]])
   (hx/f [:<>
          [Circle {:r 59  :x 15 :y 19}]
          [Circle {:r 59  :x -15 :y -19}]])])

(defn variant-idx [id]
  (let [id-suffix (or (last id) "0")
        idx (mod (js/parseInt id-suffix 16) (count placeholder-variants))]
    idx))

(defnc Placeholder [{:keys [idx] :as props}]
  [:div (nosco-react/merge-props
         {:class "placeholder-image"}
         (dissoc props :idx))
   [:div {:class "placeholder-image-inner"}
    (nth placeholder-variants idx)]])
